import { Injectable, inject } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { FreezeOverlayComponent } from './freeze-overlay.component';

@Injectable({ providedIn: 'root' })
export class FreezeOverlayService {
    private overlay = inject(Overlay);
    private ref: OverlayRef | null = null;

    show(): void {
        if (this.ref) return;

        this.ref = this.overlay.create({
            hasBackdrop: true,
            backdropClass: 'atp-freeze-backdrop',
            panelClass: 'atp-freeze-panel',
            positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
            scrollStrategy: this.overlay.scrollStrategies.block()
        });

        // Attach component
        this.ref.attach(new ComponentPortal(FreezeOverlayComponent));

        // Add global styles for backdrop once
        if (!document.getElementById('atp-freeze-global-style')) {
            const style = document.createElement('style');
            style.id = 'atp-freeze-global-style';
            style.textContent = `
        .atp-freeze-backdrop {
          background: linear-gradient(135deg, rgba(10,10,10,.45), rgba(10,10,10,.25));
          backdrop-filter: blur(3px);
          -webkit-backdrop-filter: blur(3px);
          pointer-events: auto; /* block clicks */
          cursor: wait;
        }
        .atp-freeze-panel {
          pointer-events: none;
          z-index: 1000;
        }
      `;
            document.head.appendChild(style);
        }
    }

    public hide(): void {
        if (!this.ref) return;
        this.ref.dispose();
        this.ref = null;
    }

    public setFrozen(frozen: boolean): void {
        frozen ? this.show() : this.hide();
    }
}
